// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-agent h2 {
  margin-top: 20px;
  color: #2a2f5c;
  font-size: 22px;
  font-weight: 600;
  position: relative;
}

.about-agent h3 {
  font-size: 16px;
  color: #2a2f5c;
  font-weight: 600;
  margin-top: 15px;
}

.about-agent .grouped-input select {
  appearance: none;
  background-color: transparent;
  border: none;
  padding: 0 1em 0 0;
  margin: 0;
  width: 100%;
  cursor: inherit;
  line-height: inherit;
  box-shadow: none;
  outline: none;
}

.about-agent .grouped-input .for-select {
  display: flex;
  justify-content: center;
  align-items: center;
}

.about-agent .grouped-input .fa-angle-down {
  margin-left: auto;
}

.about-agent .gray-bg {
  background-color: #e6e6e6ac;
  border: 1px solid #e6e6e6ac;
}

.about-agent .required {
  border: 1px solid #f41649;
}

.about-agent .form-data {
  margin-right: 80px;
}

.personal-info {
  padding-bottom: 40px;
  border-bottom: 1px solid #eeeeee;
}

.id-info {
  margin-top: 35px;
  padding-bottom: 40px;
  border-bottom: 1px solid #eeeeee;
}

.guarantor {
  margin-top: 35px;
  padding-bottom: 40px;
}

.about-agent .skip {
  position: absolute;
  right: 110px;
  top: 95px;
  background-color: transparent;
  color: blue;
  border: none;
  border-radius: 0;
  padding-bottom: 15px;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/view/onboarding/About.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB","sourcesContent":[".about-agent h2 {\n  margin-top: 20px;\n  color: #2a2f5c;\n  font-size: 22px;\n  font-weight: 600;\n  position: relative;\n}\n\n.about-agent h3 {\n  font-size: 16px;\n  color: #2a2f5c;\n  font-weight: 600;\n  margin-top: 15px;\n}\n\n.about-agent .grouped-input select {\n  appearance: none;\n  background-color: transparent;\n  border: none;\n  padding: 0 1em 0 0;\n  margin: 0;\n  width: 100%;\n  cursor: inherit;\n  line-height: inherit;\n  box-shadow: none;\n  outline: none;\n}\n\n.about-agent .grouped-input .for-select {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.about-agent .grouped-input .fa-angle-down {\n  margin-left: auto;\n}\n\n.about-agent .gray-bg {\n  background-color: #e6e6e6ac;\n  border: 1px solid #e6e6e6ac;\n}\n\n.about-agent .required {\n  border: 1px solid #f41649;\n}\n\n.about-agent .form-data {\n  margin-right: 80px;\n}\n\n.personal-info {\n  padding-bottom: 40px;\n  border-bottom: 1px solid #eeeeee;\n}\n\n.id-info {\n  margin-top: 35px;\n  padding-bottom: 40px;\n  border-bottom: 1px solid #eeeeee;\n}\n\n.guarantor {\n  margin-top: 35px;\n  padding-bottom: 40px;\n}\n\n.about-agent .skip {\n  position: absolute;\n  right: 110px;\n  top: 95px;\n  background-color: transparent;\n  color: blue;\n  border: none;\n  border-radius: 0;\n  padding-bottom: 15px;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
